import { IStateDrugStore } from 'src/entity/StateEntity';
import * as ActionTypes from 'src/constants/ActionTypes';

const initialState: IStateDrugStore = {
  reload: true,
  isFetching: false,
  type: ActionTypes.DRUGSTORE_STATUS_RELOAD,
  drugStores: [],
};

export const drugStoreState = (state: IStateDrugStore = initialState, action: IStateDrugStore): IStateDrugStore => {
  switch (action.type) {
    case ActionTypes.DRUGSTORE_STATUS_RELOAD:
      return Object.assign({}, state, {
        type: action.type,
        reload: true,
        isFetching: false,
        drugStores: [],
      });
    case ActionTypes.DRUGSTORE_STATUS_REQUEST:
      return Object.assign({}, state, {
        type: action.type,
        reload: false,
        isFetching: true,
        drugStores: action.drugStores || [],
      });
    case ActionTypes.DRUGSTORE_STATUS_SUCCESS:
      return Object.assign({}, state, {
        type: action.type,
        reload: false,
        isFetching: false,
        drugStores: action.drugStores || [],
      });
    case ActionTypes.DRUGSTORE_STATUS_FAILURE:
      return Object.assign({}, state, {
        type: action.type,
        reload: true,
        isFetching: false,
        drugStores: [],
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/drugStoreState.ts